export type SkuModalLayoutTab = 'price' | 'warehouse'

/** ความกว้าง modal แท็บราคา (default) */
export const SKU_MODAL_PRICE_WIDTH = 1000 as const

/** ความกว้าง modal แท็บคลัง */
export const SKU_MODAL_WAREHOUSE_WIDTH = 750 as const

export const getSkuModalContentWidth = (tab: SkuModalLayoutTab): number =>
  tab === 'warehouse' ? SKU_MODAL_WAREHOUSE_WIDTH : SKU_MODAL_PRICE_WIDTH

/** @deprecated ใช้ getSkuModalContentWidth แทน */
export const SKU_MODAL_CONTENT_WIDTH = SKU_MODAL_WAREHOUSE_WIDTH

/** ความสูงคงที่ร่วมของ modal body + expand panels — เปลี่ยนที่นี่ที่เดียว */
export const SKU_MODAL_BODY_HEIGHT = 'min(82vh, 720px)' as const

/**
 * เปิด/ปิดฟีเจอร์ "สต็อกแบบพื้นฐาน" (ผูกสต็อก SKU ของตัวเองเป็นรายการ "หลัก") ในโหมดขั้นสูง
 * ของ modal กำหนดสินค้า–ราคาและคลัง
 *  - true  = แสดง toggle "สต็อกแบบพื้นฐาน", โหมดขั้นสูง auto-เติมสต็อกตัวเองเป็นรายการแรก,
 *            และส่ง is_initial_stock_sku ตอนบันทึก
 *  - false = ซ่อน toggle, โหมดขั้นสูงไม่เติมตัวเอง (ปล่อยตารางว่าง), และไม่ส่ง is_initial
 * ปัจจุบัน default = false
 */
export const ENABLE_ADVANCED_SELF_STOCK = false as const
